import React, { useEffect, useState } from "react";
import { GoPrimitiveDot } from "react-icons/go";
import { IoNotifications, IoPeople } from "react-icons/io5";
import { FaWpforms } from "react-icons/fa";
import { MdEvent } from "react-icons/md";
import { SparkLine, StackedChart } from "../components";
import { MdOutlineCampaign } from "react-icons/md";
import {
  SparklineAreaData,
  stackedPrimaryXAxis,
  stackedPrimaryYAxis,
} from "../data/dummy";
import { useStateContext } from "../contexts/ContextProvider";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const API_KEY = process.env.REACT_APP_API_KEY;

const Home = () => {
  const { currentColor } = useStateContext();

  const [stats, setStats] = useState({
    notices: 0,
    events: 0,
    members: 0,
    feedbacks: 0,
    creditTotal: 0,
    debitTotal: 0,
    helps: 0,
    
  });

  const [stackedChartData, setStackedChartData] = useState([[], []]); // Initialize stacked chart data

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const headers = {
          "api-key": API_KEY,
        };

        const endpoints = [
          `${API_BASE_URL}/api/notices`,
          `${API_BASE_URL}/api/events`,
          `${API_BASE_URL}/api/members`,
          `${API_BASE_URL}/api/forms`,
          `${API_BASE_URL}/api/funds`,
          `${API_BASE_URL}/api/helplines`,
           // Add the funds endpoint
        ];

        const responses = await Promise.all(
          endpoints.map((url) => fetch(url, { headers }))
        );

        const [notices, events, members, forms, funds, helplines ] = await Promise.all(
          responses.map((res) => res.json())
        );

        // Calculate the totals for Credit and Debit
        const { creditTotal, debitTotal } = funds.reduce(
          (acc, fund) => {
            if (fund.type === "credit") acc.creditTotal += fund.amount;
            if (fund.type === "debit") acc.debitTotal += fund.amount;
            return acc;
          },
          { creditTotal: 0, debitTotal: 0 }
        );

        // Transform funds data for stacked chart
        const transformFundsData = (funds) => {
          const creditData = {};
          const debitData = {};

          funds.forEach((fund) => {
            const month = new Date(fund.date).toLocaleString("default", {
              month: "short",
            });
            if (fund.type === "credit") {
              creditData[month] = (creditData[month] || 0) + fund.amount;
            } else if (fund.type === "debit") {
              debitData[month] = (debitData[month] || 0) + fund.amount;
            }
          });

          const months = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
          ];

          const creditChart = months.map((month) => ({
            x: month,
            y: creditData[month] || 0,
          }));

          const debitChart = months.map((month) => ({
            x: month,
            y: debitData[month] || 0,
          }));

          return [creditChart, debitChart];
        };

        const transformedChartData = transformFundsData(funds);

        // Update the state with all the statistics
        setStats({
          notices: notices.length || 0,
          events: events.length || 0,
          members: members.length || 0,
          feedbacks: forms.length || 0, 
          creditTotal, // Store Credit Total
          debitTotal,
          helps: helplines.length || 0,
          
          
        });

        setStackedChartData(transformedChartData); // Update stacked chart data
      } catch (error) {
        console.error("Failed to fetch stats:", error);
      }
    };

    fetchStats();
  }, []);




  const stackedFundSeries = [
    {
      dataSource: stackedChartData[0],
      xName: "x",
      yName: "y",
      name: "Credit",
      type: "StackingColumn",
      background: "blue",
    },
    {
      dataSource: stackedChartData[1],
      xName: "x",
      yName: "y",
      name: "Debit",
      type: "StackingColumn",
      background: "red",
    },
  ];

  // const totalAmount = stats.creditTotal + stats.debitTotal;
  const budgets = stats.creditTotal - stats.debitTotal;

  const savings = (budgets / stats.creditTotal) * 100;


  const VaaarDetails = [
    {
      icon: <IoNotifications />,
      amount: stats.notices,
      title: "Notices",
      label: "Notices",
      iconColor: "#03C9D7",
      iconBg: "#E5FAFB",
    },
    {
      icon: <MdEvent />,
      amount: stats.events,
      title: "Events",
      label: "Events",
      iconColor: "rgb(255, 244, 229)",
      iconBg: "rgb(254, 201, 15)",
    },
    {
      icon: <IoPeople />,
      amount: stats.members,
      title: "Members",
      label: "Members",
      iconColor: "rgb(228, 106, 118)",
      iconBg: "rgb(255, 244, 229)",
    },
    {
      icon: <FaWpforms />,
      amount: stats.feedbacks,
      title: "Feedbacks",
      label: "Feedbacks",
      iconColor: "rgb(0, 194, 146)",
      iconBg: "rgb(235, 250, 242)",
    },
    {
      icon: <MdOutlineCampaign />,
      amount: stats.helps,
      title: "Helplines",
      label: "Helplines",
      iconColor: "rgb(255, 170, 0)",
      iconBg: "rgb(255, 244, 229)",
    }
  ];


  return (
    <div className="mt-12">
      <div className="flex flex-wrap lg:flex-nowrap justify-center">
        <div className="bg-white dark:text-gray-200 dark:bg-secondary-dark-bg h-44 rounded-xl w-full lg:w-80 p-8 pt-9 m-3 bg-hero-pattern bg-no-repeat bg-cover bg-center dark:bg-blend-overlay border border-gray-100 dark:border-gray-600">
          <div className="flex justify-between items-center">
            <div>
              <p className="font-bold text-4xl dark:text-gray-400 text-white">Funds</p>
              <p className="text-2xl mt-2b">₹ {stats.creditTotal}
                {/* ${stats.funds} */}
              </p>
            </div>
          </div>
          {/* <div className="mt-6">
            <Button
              color="white"
              bgColor="blue"
              text="Download"
              borderRadius="10px"
              size="md"
            />
          </div> */}
        </div>

        {/* 📝these are divs for the small stats cards
        <div className=" flex m-3 flex-wrap justify-center gap-1 items-center">
          {earningData.map((item) => (
            <div
              key={item.title}
              className="bg-white dark:text-gray-200 dark:bg-secondary-dark-bg md:w-40 p-4 pt-9 rounded-2xl"
            >
              <button type="button"
              style={{ color: item.iconColor, backgroundColor: item.iconBg }}
              className="text-2xl opacity-0.9 rounded-full p-4 hover:drop-shadow-xl">
                {item.icon}
              </button>
              <p className="mt-3">
                <span className="text-lg font-semibold">
                  {item.amount}
                </span>
                <span className={`text-sm text-${item.pcColor} ml-2`}>
                  {item.percentage}
                </span>
              </p>
            </div>
          ))}
        </div> */}
        <div className=" flex m-3 flex-wrap justify-center gap-1 items-center">
          {VaaarDetails.map((item) => (
            <div
              key={item.title}
              className="bg-white dark:text-gray-200 dark:bg-secondary-dark-bg md:w-40 p-4 pt-4 rounded-2xl text-center border border-gray-100 dark:border-gray-600"
            >
              <button
                type="button"
                style={{ color: item.iconColor, backgroundColor: item.iconBg }}
                className="text-2xl opacity-0.9 rounded-full p-4 hover:drop-shadow-xl"
              >
                {item.icon}
              </button>
              <p className="mt-3">
                <span className="text-xl font-semibold">{item.amount}</span>
                {/* <span className={`text-sm text-${item.pcColor} ml-2`}>
                  {item.percentage}
                </span> */}
              </p>

              <p className="text-md font-semibold mt-1">{item.label}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="flex gap-8 flex-wrap justify-center ">
        <div className="bg-white dark:text-gray-200 dark:bg-secondary-dark-bg m-3 p-4 rounded-2xl md:w-780 border border-gray-100 dark:border-gray-600">
          <div className="flex justify-between">
            <p className="font-semibold text-xl">Donation Updates</p>
            <div className="flex items-center gap-4">
              <p className="flex items-center gap-2 text-gray-600 hover:drop-shadow-xl">
                <span><GoPrimitiveDot /></span>
                <span>Expense</span>
              </p>
              <p className="flex items-center gap-2 text-green-400 hover:drop-shadow-xl">
                <span><GoPrimitiveDot /></span>
                <span>Budget</span>
              </p>
            </div>
          </div>
          <div className="mt-10 flex gap-10 flex-wrap justify-center">
            <div className="border-r-1 border-color m-4 pr-10">
              <div>
                <p>
                  <span className="text-3xl font-semibold">
                    ₹ {budgets}
                  </span>
                  <span
                    className={`p-1.5 hover:drop-shadow-xl cursor-pointer rounded-full text-white ml-3 text-xs ${savings < 1 ? "bg-red-400" : "bg-green-400"
                      }`}
                  >
                    {savings.toFixed(2)} %
                  </span>
                </p>
                <p className="text-gray-500 mt-1">Budgets</p>
              </div>
              <div className="mt-8">
                <p>
                  <span className="text-3xl font-semibold">
                    ₹ {stats.debitTotal}
                  </span>
                </p>
                <p className="text-gray-500 mt-1">Expense</p>
              </div>

              <div className="mt-5">
                <SparkLine
                  currentColor={currentColor}
                  id="line-sparkline"
                  type="Line"
                  height="80px"
                  width="250px"
                  data={SparklineAreaData}
                  color={currentColor}
                />
              </div>
              {/* <div className="mt-10">
                <Button
                  color="white"
                  bgColor={currentColor}
                  text="Download Report"
                  borderRadius="10px"
                  onClick={handleDownloadStackedCSV}
                /> 
              </div>*/}
            </div>
            <div>
              <StackedChart
                width="350px"
                height="360px"
                data={stackedFundSeries}
                xAxisData={stackedPrimaryXAxis}
                yAxisData={stackedPrimaryYAxis}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
